import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';


import { ProtocolEndpoint } from './protocol-endpoint.service';
import { Protocol } from '../models/protocol/protocol.model';
import { ProtocolSubmissionRule } from '../models/protocol/protocolSubmissionRule.model';
import { FullProtocol } from '../models/protocol/full-protocol.model';




@Injectable({ providedIn: 'root'})
export class ProtocolService {

  constructor(private router: Router, private http: HttpClient, private protocolEndpoint: ProtocolEndpoint) {

  }

  getProtocolById(protocolId?: number) {
    return this.protocolEndpoint.getProtocolByIdEndpoint<Protocol>(protocolId);
  }

  getFullProtocolById(protocolId?: number) {
    return this.protocolEndpoint.getFullProtocolByIdEndpoint<FullProtocol>(protocolId);
  }

  getProtocolSubmissionRules(protocolId?: number)
  {
    return this.protocolEndpoint.getProtocolSubmissionRulesEndpoint<Array<ProtocolSubmissionRule>>(protocolId);
  }

  getProtocols() {
    return this.protocolEndpoint.getProtocolsEndpoint<Array<FullProtocol>>();
  }
}
